import { batch } from 'react-redux';
import { get } from 'lodash';

import {
  FETCH_BASIC_DATA,
  FETCH_GA_DATA,
  FETCH_BRIZI_VISION_DATA,
  FETCH_PAST_EVENT_DATA,
  SET_TIMELINE_INTERVAL,
} from './types';

import {
  getBriziBasicData,
  getGAData,
  getBriziVisionData,
  getPastEventData,
} from './api';
import { displayErrorModal } from '../../helpers/swal';

const requestBasicData = () => ({ type: FETCH_BASIC_DATA });
const requestGAData = () => ({ type: FETCH_GA_DATA });
const requestBriziVision = () => ({ type: FETCH_BRIZI_VISION_DATA });
const requestPastEventData = () => ({ type: FETCH_PAST_EVENT_DATA });

export const receiveBasicData = (error, data) => ({
  type: FETCH_BASIC_DATA,
  payload: { error, data },
});

const receiveGAData = (error, data) => ({
  type: FETCH_GA_DATA,
  payload: { error, data },
});

const receiveBriziVisionData = (error, data) => ({
  type: FETCH_BRIZI_VISION_DATA,
  payload: { error, data },
});

const receivePastEventData = (error, data) => ({
  type: FETCH_PAST_EVENT_DATA,
  payload: { error, data },
});

const handleAnalyticsError = (error, getState) => {
  const { events: { selectedEvents } } = getState();
  if (error.statusCode !== 404 || get(selectedEvents, '0.eventStatus') === 'post') {
    console.error(error);
    displayErrorModal();
  }
};

const fetchBriziVisionData = (slugDate) => async (dispatch, getState) => {
  dispatch(requestBriziVision());

  try {
    const data = await getBriziVisionData(slugDate);
    dispatch(receiveBriziVisionData(undefined, data));
  } catch (err) {
    handleAnalyticsError(err, getState);
    dispatch(receiveBriziVisionData(err.message));
  }
};

const fetchGAData = (slugDate) => async (dispatch, getState) => {
  dispatch(requestGAData());

  try {
    const data = await getGAData(slugDate);
    dispatch(receiveGAData(undefined, data));
    dispatch(fetchBriziVisionData(slugDate));
  } catch (err) {
    handleAnalyticsError(err, getState);
    dispatch(receiveGAData(err.message));
    dispatch(fetchBriziVisionData(slugDate));
  }
};

const fetchBasicData = (slugDate) => async (dispatch, getState) => {
  dispatch(requestBasicData());

  try {
    const data = await getBriziBasicData(slugDate);
    dispatch(receiveBasicData(undefined, data));
    dispatch(fetchGAData(slugDate));
  } catch (err) {
    handleAnalyticsError(err, getState);
    dispatch(fetchGAData(slugDate));
    dispatch(receiveBasicData(err.message));
  }
};

const fetchPastEventData = (slugDate) => async (dispatch, getState) => {
  dispatch(requestPastEventData());

  try {
    const data = await getPastEventData(slugDate);
    dispatch(receivePastEventData(undefined, data));
  } catch (err) {
    handleAnalyticsError(err, getState);
    dispatch(receivePastEventData(err.message));
  }
};

export const fetchAnalyticsData = (slugDate) => (dispatch) => {
  batch(() => {
    dispatch(fetchBasicData(slugDate));
    dispatch(fetchPastEventData(slugDate));
  });
};

export const setTimelineInterval = (intervalMinutes) => ({
  type: SET_TIMELINE_INTERVAL,
  payload: { intervalMinutes },
});
